const state = {
  data: {},
};

const getters = {
  duplicateCustomerTemporary: (state) => state.data,
};

const actions = {};

const mutations = {
  updateDuplicateCustomerTemporary: (state, data) => (state.data = data),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
